import { useEffect, useState } from "react";
import { useAddDispatch, useAppSelector } from "../../store";
import { GetListValue } from "../common/commonSlice";
import SelectField from "../../components/select";
import { toast } from "react-toastify";
import { UpdateLoginUserData } from "../../auth/userSlice";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { getStatus } from "../common/statusMasterSlice";
import { getTopLevelMenus, isTmsModule, sortTopNavMenus } from "../../utility/layoutTheme";
import { getFirstMenuUrlForModule } from "../../utility/navMenuSearch";
import GlobalNavSearch from "./GlobalNavSearch";
import { POST } from "../../config/httpMain";
import UserManagerApiUrl from "../userManager/userManagerAPIURL";

export default function Header({
    handleNavFunc,
    parentCode,
    setParentCode
}: any) {
    const navigate = useNavigate();
    const dispatch = useAddDispatch();
    const userSlice = useAppSelector((state: any) => state.userSlice);
    const userdetail = userSlice?.user?.userdetail;
    const roles = userSlice?.user?.roles;
    const modulePermission = userSlice?.user?.modulePermission;
    const myCompanies = userSlice?.user?.myCompanies;
    const [companyData, setCompanyData] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>({ companyCode: "", companyName: "" });
    const [companyChangeData, setCompanyChangeData] = useState<any>({ showModal: false, data: null });
    const [collapse, setcollapse] = useState("");
    const [menu, setMenu] = useState<any[]>([]);

    const activeTopMenu = menu.find((m: any) => m.code === parentCode);
    const isTmsLayout = isTmsModule(activeTopMenu);
    const usePortalLayout = menu.length > 0;

    useEffect(() => {
        if (userSlice?.user) {
            let listArr = Array.from(myCompanies)
                .map((option: any) => ({ label: option?.companyName, value: option?.companyCode }));
            setCompanyData(listArr);

            if (userdetail?.companyCode) {
                document.title = `${userdetail.companyCode} Portal ${isTmsLayout ? "TMS" : "CMS"}`;
                dispatch(getStatus(userdetail.companyCode));
            }

            const _menus = sortTopNavMenus(getTopLevelMenus(modulePermission));
            if (_menus?.length > 0) {
                setMenu(_menus);
            } else {
                setParentCode(null);
                setMenu([]);
            }
        }
    }, [userSlice]);

    useEffect(() => {
        document.body.classList.toggle("layout-tms", usePortalLayout);
        return () => document.body.classList.remove("layout-tms");
    }, [usePortalLayout]);

    const sideBarIconOnly = () => {
        document.getElementById("body")?.classList.toggle("sidebar-icon-only");
    };
    const toggleFunc = (val: any) => {
        const prevValue = collapse;
        if (prevValue === val)
            setcollapse("");
        else
            setcollapse(val);

    };

    const handleSelectChange = (e: any) => {
        if (formData?.companyCode !== e?.value)
            setCompanyChangeData({ showModal: true, data: e });
    };
    const handleCompanyChangePopUpClose = () => {
        setCompanyChangeData({ showModal: false, data: null });
    };
    const handleCompanyChangeSubmit = async () => {
        const { label, value } = companyChangeData.data;
        // call API to switch company and update session storage
        let payload = {
            userId: userdetail?.id,
            companyCode: value
        }
        await POST(UserManagerApiUrl.SwitchCompany, payload).then((response: any) => {
            if (response?.data?.isSuccess) {
                let obj = response?.data?.result;
                if (obj?.code && obj?.redirectUrl)
                    window.location.href = `${obj.redirectUrl}/sso?code=${encodeURIComponent(obj.code)}`;
                else
                    toast.warning("Something went wrong");

            }
            else {
                toast.warning("Something went wrong");
            }
        }).catch((e: any) => {
            toast.error("Something went wrong");
            console.error(e?.message);
        })
    }
    const GetAllCompanyData = async () => {
        const response = (await dispatch(GetListValue({ ControlName: "allcompanies" }))).payload;
        if (response?.isSuccess) {
            let listArr = Array.from(response?.result)
                .map((option: any) => ({ label: option.label, value: option.value }));
            setCompanyData(listArr);
        }
        else
            toast.error("Something went wrong while fetching data !");
    }
    // useEffect(() => {
    //     GetAllCompanyData();
    // }, []);
    useEffect(() => {
        if (userSlice?.user) {
            setFormData({ ...formData, companyCode: userdetail?.companyCode, companyName: userdetail?.companyName });
        }
    }, [userSlice]);

    const userInitial = (userdetail?.firstName?.[0] || userdetail?.lastName?.[0] || "U").toUpperCase();

    return (
        <>
            <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
                <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                    <Link className="navbar-brand brand-logo me-5" to="/dashboard">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/${userdetail?.companyCode}-logo.png`} className="me-2" alt="logo" />
                        {process.env.REACT_APP_ENV === "QA" && <strong className="text-qa">QA</strong>}
                    </Link>
                    <Link className="navbar-brand brand-logo-mini" to="/dashboard">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/${userdetail?.companyCode}-logo.png`} alt="logo" />
                        {process.env.REACT_APP_ENV === "QA" && <strong className="text-qa">QA</strong>}
                    </Link>
                </div>
                <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
                    <button onClick={() => sideBarIconOnly()} className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                        <span className="icon-menu"></span>
                    </button>

                    {usePortalLayout && (
                        <>
                            <ul className="tms-header-tabs">
                                {menu?.map((item: any) => (
                                    <li key={`menuItem_${item?.id}`}>
                                        <button
                                            type="button"
                                            className={`tms-header-tab ${item?.code === parentCode ? "active" : ""}`}
                                            onClick={() => {
                                                if (item?.code === parentCode) return;
                                                setParentCode(item?.code);
                                                const firstUrl = getFirstMenuUrlForModule(
                                                    userSlice?.user?.modulePermission,
                                                    item?.code
                                                );
                                                if (firstUrl) handleNavFunc(firstUrl);
                                            }}
                                        >
                                            {item?.moduleName}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                            <div className="tms-header-center">
                                <GlobalNavSearch handleNavFunc={handleNavFunc} />
                            </div>
                        </>
                    )}

                    <ul className="navbar-nav navbar-nav-right">
                        <li className="nav-item">
                            <div className="navbar-nav headercompany">
                                <SelectField
                                    className=""
                                    name="companyCode"
                                    data={companyData}
                                    isLoading={false}
                                    isClearable={false}
                                    selectedValue={formData?.companyCode}
                                    onChange={handleSelectChange}
                                />
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a className={`nav-link count-indicator dropdown-toggle ${collapse == "notificationDropdown" ? "show" : ""}`} id="notificationDropdown"
                                data-bs-toggle="dropdown" onClick={() => toggleFunc("notificationDropdown")} aria-expanded={collapse == "notificationDropdown" ? "true" : "false"}>
                                <i className="icon-bell mx-0"></i>
                                <span className="count"></span>
                            </a>
                            <div className={`dropdown-menu dropdown-menu-right navbar-dropdown preview-list ${collapse == "notificationDropdown" ? "show" : ""}`}
                                aria-labelledby="notificationDropdown" data-bs-popper={collapse == "notificationDropdown" ? "static" : ""}>
                                <p className="mb-0 font-weight-normal float-left dropdown-header">Notifications</p>
                                <a className="dropdown-item preview-item">
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon bg-success">
                                            <i className="ti-info-alt mx-0"></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <h6 className="preview-subject font-weight-normal">Application Error</h6>
                                        <p className="font-weight-light small-text mb-0 text-muted">Just now</p>
                                    </div>
                                </a>
                                <a className="dropdown-item preview-item">
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon bg-warning">
                                            <i className="ti-settings mx-0"></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <h6 className="preview-subject font-weight-normal">Settings</h6>
                                        <p className="font-weight-light small-text mb-0 text-muted">Private message</p>
                                    </div>
                                </a>
                                <a className="dropdown-item preview-item">
                                    <div className="preview-thumbnail">
                                        <div className="preview-icon bg-info">
                                            <i className="ti-user mx-0"></i>
                                        </div>
                                    </div>
                                    <div className="preview-item-content">
                                        <h6 className="preview-subject font-weight-normal">New user registration</h6>
                                        <p className="font-weight-light small-text mb-0 text-muted">2 days ago</p>
                                    </div>
                                </a>
                            </div>
                        </li>
                        <li className="nav-item nav-profile dropdown">
                            <a className={collapse == "Logout" ? "nav-link dropdown-toggle show" : "nav-link dropdown-toggle"}
                                data-bs-toggle="dropdown" onClick={() => toggleFunc("Logout")} id="profileDropdown" aria-expanded={collapse == "Logout" ? "true" : "false"}>
                                {usePortalLayout ? (
                                    <span className="tms-user-avatar" title={`${userdetail?.firstName} ${userdetail?.lastName}`}>{userInitial}</span>
                                ) : (
                                    <>
                                        <strong style={{ fontSize: "large", paddingRight: "17px" }}>{userdetail?.firstName} {userdetail?.lastName} </strong>
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/icons/user.svg`} alt={`${userdetail?.firstName} ${userdetail?.lastName}`} title={`${userdetail?.firstName} ${userdetail?.lastName}`} />
                                    </>
                                )}
                            </a>
                            <div className={collapse == "Logout" ? "dropdown-menu dropdown-menu-right navbar-dropdown show" : "dropdown-menu dropdown-menu-right navbar-dropdown"} aria-labelledby="profileDropdown">
                                <a className="dropdown-item" onClick={() => handleNavFunc("/")}>
                                    <i className="ti-power-off text-primary"></i>
                                    Logout
                                </a>
                            </div>
                        </li>
                    </ul>
                    <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
                        data-toggle="offcanvas">
                        <span className="icon-menu"></span>
                    </button>
                </div>
            </nav>

            {companyChangeData.showModal &&
                <Modal isOpen={companyChangeData.showModal} toggle={handleCompanyChangePopUpClose} className="modal-sm" centered>
                    <ModalHeader toggle={handleCompanyChangePopUpClose}>Confirm Company Change</ModalHeader>
                    <ModalBody>
                        <p>Are you sure you want to change the company?</p>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn color---green" onClick={handleCompanyChangeSubmit}>Yes</button>
                        <button type="button" className="btn btn-secondary" onClick={handleCompanyChangePopUpClose}>No</button>
                    </ModalFooter>
                </Modal>
            }
        </>
    )
}
